import { SET_ADMIN_CHARTS } from "../../actions/action-types";

export default function adminCharts(state = {}, {type, payload}) {
    switch (type) {
        case SET_ADMIN_CHARTS:
            return (state = payload)
        default:
            return state
    }
}